import Model from 'src/storage/base';
import { checkSameAsAvatar, userFullName } from 'src/helpers';
import { filteredTreatments, formatFileReq } from 'src/components/user/components';

class SettingProfileModel extends Model {
  id = 'SettingProfileModel';
  persistent = false;
  defaultState = () => ({
    avatar: null,
    birthday: null,
    images: [],
    imagesRemove: []
  });
  defaultTreatments = () => ({
    name: '',
    fee: ''
  });
  apiConfig = {
    updatePatient: {
      url: 'profile/update/patient',
      validation: {
        username: 'username',
        firstName: 'firstName',
        lastName: 'lastName',
        gender: 'gender',
        birthday: 'birthday',
        countryAddress: 'countryAddress',
        stateAddress: 'stateAddress',
        cityAddress: 'cityAddress',
        address: 'address',
        zipcode: 'zipcode'
      },
      cancellable: true
    },
    updateDoctor: {
      url: 'profile/update/doctor',
      validation: {
        username: 'username',
        firstName: 'firstName',
        lastName: 'lastName',
        gender: 'string',
        birthday: 'birthday',
        specialist: 'specialist',
        description: 'description',
        doctorType: 'doctorType',
        institution: 'institution',
        yearOfStarting: 'yearOfStarting',
        treatments: 'treatments',
        address: 'address',
        stateAddress: 'stateAddress',
        countryAddress: 'countryAddress',
        cityAddress: 'cityAddress',
        zipcode: 'zipcode',
        hospitalAddress: 'hospitalAddress',
        hospitalName: 'hospitalName',
        subSpeciality: 'string'
      },
      cancellable: true
    },
    city: {
      url: 'autocomplete/city',
      validation: {
        countryCode: 'countryCode'
      }
    },
    updateClinic: {
      url: 'profile/update/clinic',
      validation: {
        username: 'username',
        name: 'name',
        specialist: 'specialist',
        description: 'description'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleProfile',
    location: 'initLocation'
  };

  initLocation = (data) => {
    this.setState({ tempCountryAddress: data.country });
  };

  handleProfile = ({ password, ...profile }) => {
    void password;
    this.setStateSilent({ user: profile });
    this.resetPersonal();
  };

  handleChangeProfile = (key, value) => {
    if (!this.state.changed) this.setStateSilent({ changed: true });
    this.resetApiState('updatePatient');
    this.resetApiState('updateDoctor');
    this.handleChange(key, value);
  };

  handleChangeAvatar = (data) => {
    if (data) {
      const user = this.state.user;
      checkSameAsAvatar(
        data,
        user?.connectedAccounts.filter((u) => !!u.avatar && u.id !== user?.id).map((u) => u.avatar)
      ).then((error) => {
        if (error)
          return model.setInvalidApi(
            user.isDoctor ? 'updateDoctor' : user.isClinic ? 'updateClinic' : 'updatePatient',
            {
              avatar: error
            }
          );
        this.setStateSilent({ changed: true });
        this.handleChange('avatar', data);
      });
    } else {
      this.setStateSilent({ changed: true });
      this.handleChange('avatar', data);
    }
  };

  savePersonal = (cb) => {
    let req = {
      username: this.input('username'),
      firstName: this.input('firstName')?.toString().trim(),
      lastName: this.input('lastName')?.toString().trim(),
      gender: this.input('gender'),
      birthday: this.input('birthday'),
      address: this.input('address'),
      cityAddress: this.input('cityAddress') || '',
      stateAddress: this.input('stateAddress') || '',
      countryAddress: this.input('countryAddress') || '',
      zipcode: this.input('zipcode')?.toString() || ''
    };
    formatFileReq(req, this.input('avatar'), this.input('images'));

    this.api('updatePatient', req, (error, data, success) => {
      if (!error) {
        this.emit('profile', data);
        this.handleChange('avatarFile', '');
        this.resetPersonal();
      }
      cb(error, data, success);
    });
  };

  savePersonalDoctor(cb) {
    const id = 'updateDoctor';
    let ruleIn = {
      ...this.getApiConfig(id).validation
    };
    const req = {};
    for (let k in ruleIn) {
      req[k] = this.input(k);
    }

    req.countryAddress = req.countryAddress || '';
    req.stateAddress = req.stateAddress || '';
    req.cityAddress = req.cityAddress || '';
    req.treatments = filteredTreatments(req.treatments);
    req.firstName = req.firstName?.toString().trim();
    req.lastName = req.lastName?.toString().trim();

    formatFileReq(req, this.input('avatar'), this.input('images'));

    this.api(id, req, (error, data, success) => {
      if (!error) {
        this.emit('profile', data);
        this.resetPersonal();
      }
      cb && cb(error, data, success);
    });
    if (this.invalid.length > 0) {
      cb && cb(true);
    }
  }

  saveClinicPersonal(cb) {
    const id = 'updateClinic';
    let ruleIn = {
      ...this.getApiConfig(id).validation
    };
    const req = {};
    for (let k in ruleIn) {
      req[k] = this.input(k);
    }

    req.name = req.name?.toString().trim();
    formatFileReq(req, this.input('avatar'), this.input('images'));

    this.api(id, req, (error, data, success) => {
      if (!error) {
        this.emit('profile', data);
        this.resetPersonal();
      }
      cb && cb(error, data, success);
    });
    if (this.invalid.length > 0) {
      cb && cb(true);
    }
  }

  resetPersonal = () => {
    let user = this.getUser() || {};
    this.resetApiState('updatePatient');
    this.resetApiState('updateDoctor');
    this.setState({
      username: user.username,
      avatar: user.avatar,
      firstName: user.firstName,
      lastName: user.lastName,
      gender: user.gender || '',
      email: user.email,
      name: user.name || userFullName(user),
      phoneNumber: user.phoneNumber,
      specialist: user.specialist || [],
      description: user.description || '',
      doctorType: user.doctorType || '',
      institution: user.institution || '',
      // speciality: user.speciality || '',
      yearOfStarting: user.yearOfStarting || null,
      treatments: user.treatments ? JSON.parse(JSON.stringify(user.treatments)) : [],
      address: user.address || '',
      cityAddress: user.cityAddress || '',
      stateAddress: user.stateAddress || '',
      countryAddress: user.countryAddress || '',
      zipcode: user.zipcode || '',
      hospitalAddress: user.hospitalAddress || '',
      hospitalName: user.hospitalName?.split('_')[0] || '',
      birthday: user.birthday || null,
      images: user.images || [],
      changed: false,
      subSpeciality: user.subSpeciality || ''
    });
  };
}

const model = new SettingProfileModel();
export default model;
